/* @flow */
import PropTypes from "prop-types";

import React from "react";
import { FormattedMessage } from "react-intl";
import ButtonIcon from "./ButtonIcon";
import { Clearfix, Well, Button } from "react-bootstrap";

class LoadMoreButton extends React.Component<{
    [x: string]: any;
}> {
    static propTypes = {
        loadmore: PropTypes.func,
        loadnext: PropTypes.number,
        loaded: PropTypes.number,
        amount: PropTypes.number,
        loadAllTranslationKey: PropTypes.string,
        inContainer: PropTypes.bool
    };

    render() {
        let content;
        if (!this.props.amount || !this.props.loadnext || !this.props.loaded) {
            const key = this.props.loadAllTranslationKey || "EX_LOAD_ALL";
            content = (
                <Button bsStyle="link" className="no-padding">
                    <a href="#" className="mfcss_load-more-articles">
                        <ButtonIcon symbol="plus" />
                        <FormattedMessage id={key} />
                    </a>
                </Button>
            );
        } else {
            content = (
                <a href="#" className="mfcss_load-more-articles">
                    <p className="text-primary pull-left">
                        <i className="icon-plus icon-lg" />
                        <FormattedMessage id="EX_LOAD_MORE" values={{ numNext: this.props.loadnext }} />
                    </p>
                    <p className="text-default pull-right">
                        <FormattedMessage
                            id="EX_LOAD_MORE_DETAILS"
                            values={{ numShown: this.props.loaded, numTotal: this.props.amount }}
                        />
                    </p>
                    <Clearfix />
                </a>
            );
        }
        if (this.props.inContainer) {
            return <div onClick={this.props.loadmore}>{content}</div>;
        } else {
            return (
                <div onClick={this.props.loadmore}>
                    <Well className="well-sm">{content}</Well>
                </div>
            );
        }
    }
}

export default LoadMoreButton;
